import { render, staticRenderFns } from "./CulturaCommunication.vue?vue&type=template&id=73b7fc2f&scoped=true"
import script from "./CulturaCommunication.vue?vue&type=script&lang=js"
export * from "./CulturaCommunication.vue?vue&type=script&lang=js"
import style0 from "./CulturaCommunication.vue?vue&type=style&index=0&id=73b7fc2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b7fc2f",
  null
  
)

export default component.exports